import React, { useState } from "react";
import FolderDetails from "../Components/FolderDetails";
import Tab from "../Components/Tab";
import ImportIcon from "../images/import.png";
import Breadcrumb from "../Components/Breadcrumb";
import ShowIcon from "../Components/ShowIcon";
import { Input } from "reactstrap";
import { CiGrid2H } from "react-icons/ci";
import { CiGrid41 } from "react-icons/ci";
import { VscSplitHorizontal } from "react-icons/vsc";
import { GrRefresh } from "react-icons/gr";
import { PiPlusSquareLight } from "react-icons/pi";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
function PageHeader(props) {
  const history = useHistory();
  return (
    <div>
      {/* <Breadcrumb breadcrumbData={props?.breadcrumbData} /> */}

      {props?.isback ? (
        <div className="page-title" onClick={() => history.goBack()}>
          <MdOutlineArrowBackIosNew size={25} cursor={"pointer"} />
          <h4>{props.title}</h4>
        </div>
      ) : null}

      {props.folder_details ? (
        <FolderDetails
          folderData={props?.folderData}
          shareFolder={(item) => props?.shareFoldertoggle(item)}
          confirmtoggle={(item) => props?.confirmFoldertoggle(item)}
          edittoggle={(item) => props?.editFoldertoggle(item)}
        />
      ) : null}
      {props.tab ? (
        <Tab
          tab={props?.tab}
          setTab={(e) => {
            props.setTab(e);
            props.setViewType("list");
          }}
          shared={props?.shared || false}
          pwTabNR={props?.pwTabNR || false}
        />
      ) : null}
      <div className="page-heading">
        <div className="page-heading-left">
          {/* {props?.leftHeader ? (
            <>
              <Input
                type="checkbox"
                style={{
                  width: "18px",
                  height: "18px",
                  border: "1px solid #131313",
                  cursor: "pointer",
                }}
                onClick={() => props?.selectAll()}
              />
              <h3>Select All</h3>
            </>
          ) : null} */}

          {/* <ShowIcon
            iconName={<GrRefresh className="iconstyle-svg" />}
            tooltip_id="refresh"
            tooltip_content="Refresh"
            onIconClick={() => console.log("Refresh click")}
            className=""
          /> */}
          {/* <ShowIcon
            iconName={<LiaUserPlusSolid className="iconstyle-svg" />}
            tooltip_id="Share"
            tooltip_content="Share"
            onIconClick={() => console.log("Share click")}
            className=""
          />
          <ShowIcon
            iconName={
              <RiFolderTransferLine className="iconstyle-svg" />
            }
            tooltip_id="move"
            tooltip_content="Move to"
            onIconClick={() => console.log("Move to click")}
            className=""
          />
          <ShowIcon
            iconName={<RiFolderAddLine className="iconstyle-svg" />}
            tooltip_id="folder_add"
            tooltip_content="Create folder"
            onIconClick={() => console.log("create folder click")}
            className=""
          />
          <ShowIcon
            iconName={<TiDeleteOutline className="iconstyle-svg" />}
            tooltip_id="delete"
            tooltip_content="Delete"
            onIconClick={() => console.log("Delete click")}
            className=""
          /> */}
        </div>
        <div className="page-heading-right">
          <div className="page-heading-right-button">
            {props.importCSV ? (
              <>
                <ShowIcon
                  iconName={
                    <PiPlusSquareLight
                      // className="iconstyle-svg"
                      style={{ color: "#ffffff", fontSize: "28px" }}
                    />
                  }
                  tooltip_id="create-pw"
                  tooltip_content="Create Password"
                  onIconClick={() => props.addpasswordToggle()}
                  className="page-heading-add-button"
                />

                <div
                  className="page-heading-csv-button"
                  onClick={() => props.csvModaltoggle()}
                >
                  <img
                    src={ImportIcon}
                    alt="Import"
                    style={{ width: "20px", height: "20px" }}
                  />
                  <h6>Import CSV</h6>
                </div>
              </>
            ) : null}
            {props.folder || props?.createEnv ? (
              <div
                className="page-heading-csv-button"
                onClick={() => props?.addFoldertoggle()}
                style={{ width: props?.createEnv ? "60px" : "160px" }}
              >
                <PiPlusSquareLight
                  // className="iconstyle-svg"
                  style={{ color: "#ffffff", fontSize: "28px" }}
                />
                {!props?.createEnv ? <h6>Create folder</h6> : null}
              </div>
            ) : null}
          </div>
          <div className="page-heading-right-icon">
            <div className="page-heading-right-icon-grid">
              <ShowIcon
                iconName={<CiGrid2H className="iconstyle-svg" />}
                tooltip_id="list"
                tooltip_content="List View"
                onIconClick={() => props.setViewType("list")}
                className={
                  props.viewType === "list"
                    ? "page-heading-right-icon-grid-active"
                    : ""
                }
              />
              {props.splitIcon ? (
                <ShowIcon
                  iconName={
                    <VscSplitHorizontal className="iconstyle-svg" />
                  }
                  tooltip_id="split"
                  tooltip_content="Split View"
                  onIconClick={() => props.setViewType("split")}
                  className={
                    props.viewType === "split"
                      ? "page-heading-right-icon-grid-active"
                      : ""
                  }
                />
              ) : (
                <ShowIcon
                  iconName={<CiGrid41 className="iconstyle-svg" />}
                  tooltip_id="grid"
                  tooltip_content="Split View"
                  onIconClick={() => props.setViewType("grid")}
                  className={
                    props.viewType === "grid"
                      ? "page-heading-right-icon-grid-active"
                      : ""
                  }
                />
              )}
            </div>
            {/* <ShowIcon
              iconName={<GoFilter className="iconstyle-svg" />}
              tooltip_id="filter"
              tooltip_content="Filter"
              onIconClick={() => console.log("filter click")}
              className=""
            /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageHeader;
